/*
*
* File JS componente Banner Swiper
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//
import './banner-swiper.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const bannerSwiper = () => {

    let sectionSwiper = document.querySelectorAll('.banner-swiper .banner-swiper__swiper');
    if(!sectionSwiper.length) return;
    
    sectionSwiper.forEach(el => {
        
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let args = {
            slidesPerView: 'auto',
            breakpoints: {
                0: {
                    spaceBetween: 40
                },
                // 480: {
                //     slidesPerView: 1.5,
                //     spaceBetween: 40
                // },
                // 580: {
                //     slidesPerView: 1.8,
                //     spaceBetween: 40
                // },
                // 660: {
                //     slidesPerView: 2,
                //     spaceBetween: 40
                // },
                // 840: {
                //     slidesPerView: 2.5,
                //     spaceBetween: 40,
                // },
                965: {
                    spaceBetween: 70
                },
                1400 : {
                  slidesPerView: 4,
                  spaceBetween: 30
                }
            },
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                type: 'bullets',
                clickable: true
            },
            modules: [Navigation, Pagination],
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el.querySelector('.swiper'), args);
    })
}

export default bannerSwiper;

//--------------------------------------------------------------------//